import { JobMatchQueryFilter } from "../../../../../models/jobMatchQueryFilter";
import { OverrideNoteDetail } from "../../../../../models/overrideNoteDetail";
import { JobMatchAction } from "../../../../../models/jobMatchAction";
import { MatchedCandidatesContainer } from "./matched-candidates-infinite-scroll-container";
import { AssociateCandidateQueryFilter } from "src/app/public/app/models/associateCandidatesQueryFilter";
import { AssociateCandidateDisplayQueryFilter } from "src/app/public/app/models/associateCandidateDisplayQueryFilter";
import * as AssociatesCandidateActionsModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates-action-modal.html';
import * as CandidateSendOutreachEmailModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-send-outreach-email-modal.html';
class AssociateCandidatesController {
    /*@ngInject*/
    constructor($rootScope, $scope, $timeout, $uibModal, $filter, jobService, jobMatchActionsService, candidateService, jobMatchService, companyService, genericService, modalService, debounceService, alertsAndNotificationsService, requisitionService, MESSAGECONSTANTS) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.jobService = jobService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.candidateService = candidateService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.genericService = genericService;
        this.modalService = modalService;
        this.debounceService = debounceService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.requisitionService = requisitionService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    $onInit() {
        this.isLoading = true;
        //variables
        this._initVariables();
        this.getSalaryDurationOptions();
        this.getCurrencyCodes();
        this.getJobDetails(() => {
            this.getAllWorkLocations(() => {
                this.getAllWorkAuthorizations(() => {
                    this.getAllPreferredJobTypes(() => {
                        this.getAllAdditionalPreferredJobTypes(() => {
                            this.associateCandidatesDefaultFilter = new AssociateCandidateQueryFilter();
                            this._setAllAssociatedCandidatesFilters(this.associateCandidatesDefaultFilter);
                            this.associateCandidatesDefaultFilterCopy = _.cloneDeep(this.associateCandidatesDefaultFilter);
                            this.matchedCandidatesContainer = new MatchedCandidatesContainer(this.$rootScope.userDetails.id, this.$rootScope.userDetails.company.companyId, this.jobId, this.associateCandidatesDefaultFilter, this.jobDetails, this.defaultPageSize, this.jobMatchService, this.jobService, this.candidateService, this.alertsAndNotificationsService);
                            this.createJobMatchesObject = {
                                companyId: this.$rootScope.userDetails.company.companyId,
                                requisitionId: this.jobId,
                                candidateIds: [],
                                isAddCandidate: false,
                                isAssociateCandidate: true,
                                overrideNoteDetails: []
                            };
                            this._setQueryFilter();
                            this.sortRequisitions('Score Desc', 'Score', 'Desc');
                            this._createMatchScoreSlider();
                            this.isFiltersChanged = false;
                            this.isLoading = false;
                        });
                    });
                });
            });
            this._setDisplayFilter();
            this._setResumeOptions();
            this.searchCandidates = _.debounce(this.searchCandidates, 500);
        });
        this._checkIfOutreachEnabled();
    }
    _setDisplayFilter() {
        this.displayAssociateCandidateSelectedFilter = new AssociateCandidateDisplayQueryFilter();
        this.showCandidateDisplaySelectedFilterPanel = this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
    }
    _setQueryFilter() {
        $(document).ready(() => {
            this.isFilterOpen = true;
            $("#associate-search-panel").animate({
                height: 'toggle'
            });
            $(document).off("click", "#open-associate-filter").on("click", "#open-associate-filter", () => {
                $("#associate-search-panel").animate({
                    height: 'toggle'
                });
                this.isFilterOpen = !this.isFilterOpen;
            });
        });
    }
    searchCandidates() {
        this.searchForMatchingCandidates();
    }
    _initVariables() {
        this.jobDetails;
        this.associateCandidatesDefaultFilter = {};
        this.associateCandidatesDefaultFilterCopy = {};
        this.matchedCandidatesContainer = null;
        this.createJobMatchesObject = null;
        this.minimumScoreSliderPadding = 0;
        this.maximumScoreSliderPadding = 100;
        this.maximumScoreSliderTopPosition = 0;
        this.defaultPageSize = 18;
        this.warningModal;
        this.lastModifiedOptions = [
            { text: 'Any Time', value: 0 },
            { text: '1 day', value: 1 },
            { text: '2 days', value: 2 },
            { text: '3 days', value: 3 },
            { text: '1 week', value: 7 },
            { text: '2 weeks', value: 14 },
            { text: '1 month', value: 30 },
            { text: '3 months', value: 90 },
            { text: '6 months', value: 180 },
            { text: '1 year', value: 365 }
        ];
        this.topMatchesOptions = [
            { text: 'All', value: 0 },
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '75', value: 75 },
            { text: '100', value: 100 },
            { text: '200', value: 200 }
        ];
        this.clientOrBuLabel = 'Client';
        this.workLocations = [];
        this.workAuthorizationList = [];
        this.jobTypeList = [];
        this.jobTypeAdditionalList = [];
        this.selectedWorkLocations = [];
        this.selectedJobTypeList = [];
        this.selectedJobTypeAdditionalList = [];
        this.selectedWorkAuthorizationList = [];
        this.filterSalaryDurationOptions = [];
        this.filterRateDurationOptions = [];
        this.selectedSort = "Please Select";
        this.candidateFilterItemsSelected = [];
        // flags
        this.savingFlag = false;
        this.selectAllCandidatesFlag = false;
        this.isAssociateCandidateForCorp = false;
        this.isUploadResumeOnlyEnabled = false;
        this.loadingJobTypeFilter = true;
        this.loadingAdditionalJobTypeFilter = true;
        this.loadingWorkAuthorizationFilter = true;
        this.isPreferredJobTypeFullTime = false;
        this.isPreferredJobTypeNotFullTime = false;
        this.isFilterOpen = false;
        this.emptyCandidateSelectedFilter = false;
        this.isDisplayRateFilterActive = false;
        this.isOutreachEnabled = false;
        this.noAdditionalDetails = true;
        this.isClearClicked = false;
        if (this.$rootScope.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBuLabel = 'BU';
        }
        this.isAssociateCandidateForCorp = this.companyService.isCorporateCompany() || (!_.isUndefined(this.corporateId) && this.corporateId !== "");
    }
    getJobDetails(successCallback) {
        this.jobService.getJobProfile(this.jobId, (data) => {
            this.jobDetails = data;
            this.jobDetails.jobSalaryDto = this.jobDetails.jobSalary;
            // this.noAdditionalDetails = this.jobDetails.includeCandidatesWithNoAdditionalDetails;
            this._massageRequisitionCardInfo(this.jobDetails);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllWorkLocations(successCallback) {
        this.jobService.getWorkLocations((data) => {
            this.workLocations = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
            let tempSalaryDurationOptions = _.cloneDeep(data);
            tempSalaryDurationOptions.map(duration => {
                duration.name = duration.name.slice(4);
            });
            this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter(salaryDuration => salaryDuration.value === 'PER_YEAR');
            this.filterRateDurationOptions = tempSalaryDurationOptions.filter(salaryDuration => salaryDuration.value != 'PER_YEAR');
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllPreferredJobTypes(successCallback) {
        this.loadingJobTypeFilter = true;
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
            this.jobTypeList.push({ name: "No Pref. Job Type", value: "NO_PREF_JOBTYPE" });
            if (successCallback) {
                successCallback();
            }
            this.loadingJobTypeFilter = false;
        }, (error) => {
            this.loadingJobTypeFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllAdditionalPreferredJobTypes(successCallback) {
        this.loadingAdditionalJobTypeFilter = true;
        this.jobService.getAllJobSubTypes((data) => {
            this.jobTypeAdditionalList = data;
            this.jobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });
            if (successCallback) {
                successCallback();
            }
            this.loadingAdditionalJobTypeFilter = false;
        }, (error) => {
            this.loadingAdditionalJobTypeFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllWorkAuthorizations(successCallback) {
        this.loadingWorkAuthorizationFilter = true;
        this.jobService.getAllSponsorshipTypes((data) => {
            this.workAuthorizationList = data;
            this.jobDetails.sponsorshipsTextList = [];
            if (this.jobDetails.sponsorships && this.jobDetails.sponsorships.length > 0) {
                this.jobDetails.sponsorshipsTextList = this.workAuthorizationList
                    .filter(val => this.jobDetails.sponsorships.includes(val.value))
                    .map(val => val.name);
            }
            if (successCallback) {
                successCallback();
            }
            this.loadingWorkAuthorizationFilter = false;
        }, (error) => {
            this.loadingWorkAuthorizationFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getCurrencyCodes() {
        this.jobService.getCurrencyCodes((data) => {
            this.currencyCodes = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _massageRequisitionCardInfo(data) {
        let massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
        angular.merge(this.jobDetails, massagedRequisitionInfo.data);
    }
    _checkIfOutreachEnabled() {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    }
    _setAllAssociatedCandidatesFilters(associateCandidatesDefaultFilter) {
        if (this.jobDetails.workLocations && this.jobDetails.workLocations.length > 0) {
            this._setWorkLocations();
            associateCandidatesDefaultFilter.workLocationIds = this.jobDetails.workLocations.map(workLocation => workLocation.id);
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.workLocationIds.push('NO_WORK_LOCATION');
            }
        }
        if (this.jobDetails.jobType && this.jobDetails.jobType != "") {
            this._setPreferredJobType();
            associateCandidatesDefaultFilter.jobTypes.push(this.jobTypeList.filter(jobType => jobType.name === this.jobDetails.jobType)[0].value);
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.jobTypes.push('NO_PREF_JOBTYPE');
            }
        }
        if (this.jobDetails.sponsorships && this.jobDetails.sponsorships.length > 0) {
            this._setWorkAuthorizations();
            associateCandidatesDefaultFilter.sponsorships = this.jobDetails.sponsorships;
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.sponsorships.push('NO_WORK_AUTHORIZATION_SPECIFIED');
            }
        }
        this._setSalaryOrRate(associateCandidatesDefaultFilter);
        associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails = this.noAdditionalDetails;
    }
    _setWorkLocations() {
        this.selectedWorkLocations = this.workLocations.filter(workLocation => this.jobDetails.workLocations.some(value => workLocation.id === value.id));
        if (this.noAdditionalDetails) {
            this.workLocations.forEach(workLocation => {
                if (workLocation.name == 'No Work Location') {
                    workLocation.ticked = true;
                }
            });
            let noWorkLocation = this.workLocations.filter(workLocation => this.jobDetails.workLocations.some(value => workLocation.name === 'No Work Location'));
            this.selectedWorkLocations = noWorkLocation ? [...this.selectedWorkLocations, ...noWorkLocation] : this.selectedWorkLocations;
        }
        this.selectedWorkLocations.forEach(work => work.ticked = true);
        this._setAssociateCandidateDisplayFilters('workLocations');
    }
    _setAssociateCandidateDisplayFilters(type) {
        this.isFiltersChanged = true;
        switch (type) {
            case 'workLocations':
                this.displayAssociateCandidateSelectedFilter.workLocationIds = this.selectedWorkLocations.map((val, index) => {
                    return val.name;
                });
                break;
            case 'sponsorships':
                this.displayAssociateCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val, index) => {
                    return val.name;
                });
                break;
            case 'jobTypes':
                this.displayAssociateCandidateSelectedFilter.jobTypes = this.selectedJobTypeList.map((val, index) => {
                    return val.name;
                });
                break;
            case 'jobSubTypes':
                this.displayAssociateCandidateSelectedFilter.jobSubTypes = this.selectedJobTypeAdditionalList.map((val, index) => {
                    return val.name;
                });
                break;
            case 'salary':
                this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
                break;
            case 'rate':
                this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
                this.isDisplayRateFilterActive = true;
                break;
            default:
            // Do Nothing
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    _setJobMatchScoreDisplayFilter(minScore, maxScore) {
        let score = "";
        if (minScore === this.jobDetails.fourDotFiveIntelligenceScore && maxScore === 100) {
            score = "";
        }
        else {
            score = `From ${minScore} To ${maxScore}`;
        }
        return score;
    }
    onWorkLocationSelected() {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.workLocationIds = this.selectedWorkLocations.map(location => location.id);
        this._setAssociateCandidateDisplayFilters('workLocations');
    }
    onJobTypeSelected() {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.jobTypes = this.selectedJobTypeList.map((val, index) => {
            return val.value;
        });
        this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this._setAssociateCandidateDisplayFilters('jobTypes');
    }
    onAdditionalJobTypeSelected() {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.jobSubTypes = this.selectedJobTypeAdditionalList.map((val, index) => {
            return val.value;
        });
        this._setAssociateCandidateDisplayFilters('jobSubTypes');
    }
    onWorkAuthorizationSelected() {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.sponsorships = this.selectedWorkAuthorizationList.map((val, index) => {
            return val.value;
        });
        this._setAssociateCandidateDisplayFilters('sponsorships');
    }
    onSalaryDurationChange() {
        if (this.matchedCandidatesContainer.searchObject.salaryDuration) {
            this._setAssociateCandidateDisplayFilters('salary');
        }
    }
    onRateDurationChange() {
        if (this.matchedCandidatesContainer.searchObject.rateDuration) {
            this._setAssociateCandidateDisplayFilters('rate');
        }
    }
    onSalaryOrRateCurrencyChange(type) {
        this.isFiltersChanged = true;
        if (this.displayAssociateCandidateSelectedFilter.rate != "" || this.displayAssociateCandidateSelectedFilter.salary != "") {
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        else if (type === 'salary') {
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        else {
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
    }
    _setWorkAuthorizations() {
        this.selectedWorkAuthorizationList = this.workAuthorizationList.filter(work => this.jobDetails.sponsorships.some(value => work.value === value));
        if (this.noAdditionalDetails) {
            this.workAuthorizationList.forEach(workAuth => {
                if (workAuth.name == 'No Work Authorization') {
                    workAuth.ticked = true;
                }
            });
            let noWorkAuthorization = this.workAuthorizationList.filter(work => this.jobDetails.sponsorships.some(value => work.name === 'No Work Authorization'));
            this.selectedWorkAuthorizationList = noWorkAuthorization ? [...this.selectedWorkAuthorizationList, ...noWorkAuthorization] : this.selectedWorkAuthorizationList;
        }
        this.selectedWorkAuthorizationList.forEach(work => work.ticked = true);
        this._setAssociateCandidateDisplayFilters('sponsorships');
    }
    _setPreferredJobType() {
        this.selectedJobTypeList = this.jobTypeList.filter(jobType => jobType.name === this.jobDetails.jobType);
        if (this.noAdditionalDetails) {
            this.jobTypeList.forEach(jobType => {
                if (jobType.name == 'No Pref. Job Type') {
                    jobType.ticked = true;
                }
            });
            let noPreferredJobType = this.jobTypeList.filter(jobType => jobType.name === 'No Pref. Job Type');
            this.selectedJobTypeList = noPreferredJobType ? [...this.selectedJobTypeList, ...noPreferredJobType] : this.selectedJobTypeList;
        }
        this.selectedJobTypeList.forEach(jobType => jobType.ticked = true);
        this._setAssociateCandidateDisplayFilters('jobTypes');
    }
    _setSalaryAndRateDisplayFilter(type) {
        let salaryOrRateFilter = "";
        if (type === 'salary') {
            salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.salary ?
                `${this.matchedCandidatesContainer.searchObject.salary.toString() + " " + this.matchedCandidatesContainer.searchObject.salaryCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('salary') + this._setSalaryOrRateNotSpecified('salary')}` : "";
        }
        else {
            salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.rate ?
                `${this.matchedCandidatesContainer.searchObject.rate.toString() + " " + this.matchedCandidatesContainer.searchObject.rateCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('rate') + this._setSalaryOrRateNotSpecified('rate')}` : "";
        }
        return salaryOrRateFilter;
    }
    _setDisplayFilterSalaryOrRateDuration(type) {
        let durationOption = "";
        if (!this.salaryDurationOptions) {
            return durationOption;
        }
        if (type === 'salary') {
            const match = this.salaryDurationOptions.find(val => this.matchedCandidatesContainer.searchObject.salaryDuration === val.value);
            durationOption = match ? match.name : "";
        }
        else {
            const match = this.salaryDurationOptions.find(val => this.matchedCandidatesContainer.searchObject.rateDuration === val.value);
            durationOption = match ? match.name : "";
        }
        return durationOption;
    }
    addToDisplayFilters(event) {
        switch (event) {
            case 'search':
                this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
                break;
            default:
                break;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    _setSalaryOrRate(filter) {
        if (this.jobDetails.jobSalary) {
            filter.currency = this.jobDetails.jobSalary.currency;
            if (this.jobDetails.jobSalary.salaryDuration === 'PER_YEAR') {
                filter.salaryDuration = this.jobDetails.jobSalary.salaryDuration;
                filter.salary = this.jobDetails.jobSalary.maxSalary;
                const salaryDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find(val => filter.salaryDuration === val.value);
                this.displayAssociateCandidateSelectedFilter.salary = filter.salary && salaryDurationMatch ? `${filter.salary.toString() + " " + filter.currency + " " + salaryDurationMatch.name}` : "";
            }
            else {
                filter.rateDuration = this.jobDetails.jobSalary.salaryDuration;
                filter.rate = this.jobDetails.jobSalary.maxSalary;
                const rateDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find(val => filter.rateDuration === val.value);
                this.displayAssociateCandidateSelectedFilter.rate = filter.rate && rateDurationMatch ? `${filter.rate.toString() + " " + filter.currency + " " + rateDurationMatch.name}` : "";
            }
            if (this.associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails) {
                if (filter.salary) {
                    this.displayAssociateCandidateSelectedFilter.salary = this.displayAssociateCandidateSelectedFilter.salary + " OR Salary = Not Specified";
                }
                if (filter.rate) {
                    this.displayAssociateCandidateSelectedFilter.rate = this.displayAssociateCandidateSelectedFilter.rate + " OR Rate = Not Specified";
                }
            }
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    checkPreferredJobType(jobType) {
        let isJobTypePresent;
        if (this.selectedJobTypeList && this.selectedJobTypeList.length > 0) {
            for (let i = 0; i < this.selectedJobTypeList.length; i++) {
                if (this.selectedJobTypeList[i].value === jobType) {
                    isJobTypePresent = true;
                    break;
                }
                else {
                    isJobTypePresent = false;
                }
            }
        }
        else {
            isJobTypePresent = false;
        }
        return isJobTypePresent;
    }
    sortRequisitions(sortColumn, selectedSort, selectedSortDir) {
        this.isFiltersChanged = true;
        this.selectedSort = selectedSort;
        this.selectedSortDir = selectedSortDir;
        this.matchedCandidatesContainer.searchObject.column = "";
        this.matchedCandidatesContainer.searchObject.sortDirection = "";
        if (angular.isDefined(sortColumn) && sortColumn != "") {
            var array = sortColumn.split(" ");
            this.matchedCandidatesContainer.searchObject.column = array[0];
            this.matchedCandidatesContainer.searchObject.sortDirection = array[1];
        }
        this.displayAssociateCandidateSelectedFilter.selectedFilterSort = "";
        if (this.selectedSort != 'Please Select') {
            this.displayAssociateCandidateSelectedFilter.selectedFilterSort = this.selectedSort + " " + "(" + this.selectedSortDir + ")";
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    selectRemoveAll(label, type, doQueryFlag) {
        if (type == 'selectAll') {
            switch (label) {
                case 'workLocations':
                    this.selectedWorkLocations = [...this.workLocations];
                    this.onWorkLocationSelected();
                    break;
                case 'jobType':
                    this.selectedJobTypeList = [...this.jobTypeList];
                    this.onJobTypeSelected();
                    break;
                case 'jobSubTypes':
                    this.selectedJobTypeAdditionalList = [...this.jobTypeAdditionalList];
                    this.onAdditionalJobTypeSelected();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [...this.workAuthorizationList];
                    this.onWorkAuthorizationSelected();
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'workLocations':
                    this.selectedWorkLocations = [];
                    this.onWorkLocationSelected();
                    break;
                case 'jobType':
                    this.selectedJobTypeList = [];
                    this.onJobTypeSelected();
                    break;
                case 'jobSubTypes':
                    this.selectedJobTypeAdditionalList = [];
                    this.onAdditionalJobTypeSelected();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [];
                    this.onWorkAuthorizationSelected();
                    break;
                default:
                //do nothing
            }
        }
    }
    resetAssociateCandidatesFilters(type) {
        this.isFiltersChanged = true;
        this.isClearClicked = type === 'reset' ? false : true;
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            this.matchedCandidatesContainer.searchObject.searchText = "";
            this.displayAssociateCandidateSelectedFilter.searchText = '';
            this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = type === 'reset' ? true : false;
        }
        else if (!this.matchedCandidatesContainer.searchByTextFlag) {
            this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
            this.matchedCandidatesContainer.topMatches = 0;
            this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
            this.displayAssociateCandidateSelectedFilter.score = '';
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
        }
        this.displayAssociateCandidateSelectedFilter.workLocationIds = [];
        if (this.associateCandidatesDefaultFilterCopy.workLocationIds && this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && type === 'reset') {
            this.workLocations.forEach(workLocation => {
                if (this.associateCandidatesDefaultFilterCopy.workLocationIds.includes(workLocation.id)) {
                    workLocation.ticked = true;
                    this.displayAssociateCandidateSelectedFilter.workLocationIds.push(workLocation.name);
                }
                else {
                    workLocation.ticked = false;
                }
            });
        }
        else {
            this.workLocations.forEach(workLocation => workLocation.ticked = false);
        }
        this.matchedCandidatesContainer.searchObject.workLocationIds = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.workLocationIds : [];
        this.displayAssociateCandidateSelectedFilter.sponsorships = [];
        if (this.associateCandidatesDefaultFilterCopy.sponsorships && this.associateCandidatesDefaultFilterCopy.sponsorships.length && type === 'reset') {
            this.workAuthorizationList.forEach(work => {
                if (this.associateCandidatesDefaultFilterCopy.sponsorships.includes(work.value)) {
                    this.displayAssociateCandidateSelectedFilter.sponsorships.push(work.name);
                    work.ticked = true;
                }
                else {
                    work.ticked = false;
                }
            });
        }
        else {
            this.workAuthorizationList.forEach(work => work.ticked = false);
        }
        this.matchedCandidatesContainer.searchObject.sponsorships = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.sponsorships : [];
        this.displayAssociateCandidateSelectedFilter.jobTypes = [];
        if (this.associateCandidatesDefaultFilterCopy.jobTypes && this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && type === 'reset') {
            this.jobTypeList.forEach(jobType => {
                if (this.associateCandidatesDefaultFilterCopy.jobTypes.includes(jobType.value)) {
                    this.displayAssociateCandidateSelectedFilter.jobTypes.push(jobType.name);
                    jobType.ticked = true;
                }
                else {
                    jobType.ticked = false;
                }
            });
        }
        else {
            this.jobTypeList.forEach(jobType => jobType.ticked = false);
        }
        this.matchedCandidatesContainer.searchObject.jobTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobTypes : [];
        this.displayAssociateCandidateSelectedFilter.jobSubTypes = [];
        if (this.associateCandidatesDefaultFilterCopy.jobSubTypes && this.associateCandidatesDefaultFilterCopy.jobSubTypes.length > 0 && type === 'reset') {
            this.jobTypeAdditionalList.forEach(jobSubType => {
                if (this.associateCandidatesDefaultFilterCopy.jobSubType.includes(jobSubType.value)) {
                    this.displayAssociateCandidateSelectedFilter.jobSubTypes.push(jobSubType.name);
                    jobSubType.ticked = true;
                }
                else {
                    jobSubType.ticked = false;
                }
            });
        }
        else {
            this.jobTypeAdditionalList.forEach(jobSubType => jobSubType.ticked = false);
        }
        this.matchedCandidatesContainer.searchObject.jobSubTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobSubTypes : [];
        this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.includeCandidatesWithNoAdditionalDetails : false;
        // Set Salary and Rate
        this.matchedCandidatesContainer.searchObject.salary = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.salary : null;
        this.matchedCandidatesContainer.searchObject.rate = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.rate : null;
        this.matchedCandidatesContainer.searchObject.salaryDuration = this.associateCandidatesDefaultFilterCopy.salaryDuration;
        this.matchedCandidatesContainer.searchObject.rateDuration = this.associateCandidatesDefaultFilterCopy.rateDuration;
        this.matchedCandidatesContainer.searchObject.salaryCurrency = this.associateCandidatesDefaultFilterCopy.salaryCurrency;
        this.matchedCandidatesContainer.searchObject.rateCurrency = this.associateCandidatesDefaultFilterCopy.rateCurrency;
        this.displayAssociateCandidateSelectedFilter.salary = type === 'reset' ? this._setSalaryAndRateDisplayFilter('salary') : "";
        this.displayAssociateCandidateSelectedFilter.rate = type === 'reset' ? this._setSalaryAndRateDisplayFilter('rate') : "";
        // Set Scroll
        this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
        this.matchedCandidatesContainer.searchObject.maximumScore = 100;
        this._createMatchScoreSlider();
        // Set Sort
        if (type === 'clear') {
            this.sortRequisitions('', 'Please Select', '');
            this.matchedCandidatesContainer.searchObject.column = "Score";
            this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
        }
        else {
            if (this.matchedCandidatesContainer.searchByTextFlag) {
                this.sortRequisitions('Score Desc', 'Score', 'Desc');
                this.matchedCandidatesContainer.searchObject.column = "Score";
                this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
            }
            else if (!this.matchedCandidatesContainer.searchByTextFlag) {
                this.sortRequisitions('Score Desc', 'Score', 'Desc');
                this.matchedCandidatesContainer.searchObject.column = "Score";
                this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
            }
        }
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
    }
    onGlobalFilterChange(event) {
        this.isFiltersChanged = true;
        if (!this.isFilterOpen) {
            $("#associate-search-panel").animate({
                height: 'toggle'
            });
            this.isFilterOpen = !this.isFilterOpen;
        }
    }
    displaySelectedFilterToggle() {
        this.showCandidateDisplaySelectedFilterPanel = true;
        if (this.displayCandidateFilterFlag) {
            $("#display-Associate-candidate-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowCandidateDisplayFilterIcon(this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon);
    }
    _setObjectVariableName(currentObject) {
        let selectedFilterVariableNameObj = {
            searchText: "Search", numberOfDays: "Last Modified", topMatches: "Top Matches", workLocationIds: "Work Locations",
            jobTypes: "Job Type", jobSubTypes: "Additional Contract Types", sponsorships: "Work Authorizations", salary: "Salary",
            rate: "Rate", selectedFilterSort: "Sort By", score: "Job Match Score"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    }
    setCandidateDisplayedFilterItemSelected(itemsSelected) {
        this.emptyCandidateSelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateFilterItemsSelected.length !== 0) {
                        this.candidateFilterItemsSelected.forEach((filterItem) => {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(item => item.variable !== this.displaySelectedFilterObj.variable);
                    }
                    this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(item => item.filter !== key);
                    }
                }
            }
        }
        if (this.candidateFilterItemsSelected.length === 0) {
            if (!this.matchedCandidatesContainer.isFilterOn) {
                this.displayCandidateFilterFlag = false;
                this._setShowCandidateDisplayFilterIcon(true);
            }
            else {
                this.emptyCandidateSelectedFilter = true;
            }
        }
    }
    _setShowCandidateDisplayFilterIcon(boolean) {
        if (this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon !== boolean) {
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        }
    }
    isFilterValueArray(value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    }
    _deleteSelectedItem(currentObject, deletedItem) {
        switch (currentObject.variable) {
            case 'searchText':
                this.matchedCandidatesContainer.searchObject.searchText = '';
                this.displayAssociateCandidateSelectedFilter.searchText = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'score':
                this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
                this.matchedCandidatesContainer.searchObject.maximumScore = 100;
                this._createMatchScoreSlider();
                this.displayAssociateCandidateSelectedFilter.score = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'numberOfDays':
                this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
                this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'topMatches':
                this.matchedCandidatesContainer.searchObject.topMatches = 0;
                this.matchedCandidatesContainer.topMatches = 0;
                this.displayAssociateCandidateSelectedFilter.topMatches = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'workLocationIds':
                this.workLocations.forEach((workLocation, index) => {
                    if (workLocation.name === deletedItem) {
                        workLocation.ticked = false;
                        this.selectedWorkLocations = this.selectedWorkLocations.filter(item => item.name !== deletedItem);
                    }
                });
                this.onWorkLocationSelected();
                break;
            case 'jobTypes':
                this.jobTypeList.forEach((jobType, index) => {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        this.selectedJobTypeList = this.selectedJobTypeList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onJobTypeSelected();
                break;
            case 'jobSubTypes':
                this.jobTypeAdditionalList.forEach((additionalJobType, index) => {
                    if (additionalJobType.name === deletedItem) {
                        additionalJobType.ticked = false;
                        this.selectedJobTypeAdditionalList = this.selectedJobTypeAdditionalList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onAdditionalJobTypeSelected();
                break;
            case 'sponsorships':
                this.workAuthorizationList.forEach((sponsorship, index) => {
                    if (sponsorship.value === deletedItem) {
                        sponsorship.ticked = false;
                        this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.value !== deletedItem);
                    }
                    else if (sponsorship.name === deletedItem) {
                        sponsorship.ticked = false;
                        this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onWorkAuthorizationSelected();
                break;
            case 'salary':
                this.matchedCandidatesContainer.searchObject.salary = null;
                this.displayAssociateCandidateSelectedFilter.salary = "";
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'rate':
                this.matchedCandidatesContainer.searchObject.rate = null;
                this.displayAssociateCandidateSelectedFilter.rate = "";
                this.isDisplayRateFilterActive = false;
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'selectedFilterSort':
                this.sortRequisitions('', 'Please Select', '');
                break;
            default:
                break;
        }
    }
    deleteSelectedFilterItem(deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayAssociateCandidateSelectedFilter) {
            if (this.displayAssociateCandidateSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayAssociateCandidateSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    }
    _setOpenGlobalFilter() {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    }
    _setResumeOptions() {
        let companyIdToCheckAUploadResumeAccess;
        // // include clientOrBuId only for staffing company client
        if (this.isAssociateCandidateForCorp) {
            this.clientOrBuId = null;
        }
        if (!_.isUndefined(this.corporateId) && this.corporateId !== "") {
            companyIdToCheckAUploadResumeAccess = this.corporateId;
        }
        else {
            companyIdToCheckAUploadResumeAccess = this.$rootScope.userDetails.company.companyId;
        }
        // //Check for resume options only for external reqs and shared reqs
        if ((this.isSharedRequisition && !_.isUndefined(this.corporateId) && this.corporateId !== "") || (!this.isAssociateCandidateForCorp)) {
            this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, (data) => {
                this.isUploadResumeOnlyEnabled = data;
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.isUploadResumeOnlyEnabled = false;
        }
    }
    checkIfSalaryOrRateDefined(type) {
        let isNoPrefJobTypeSelected = this.selectedJobTypeList.some(item => item && item.value === 'NO_PREF_JOBTYPE');
        if (type === 'salary') {
            if (_.isUndefined(this.matchedCandidatesContainer.searchObject.salary) || this.matchedCandidatesContainer.searchObject.salary < 0) {
                this.matchedCandidatesContainer.searchObject.salary = 1;
            }
            this._setAssociateCandidateDisplayFilters('salary');
            if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
                (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
                this._setAssociateCandidateDisplayFilters('rate');
            }
        }
        else if (type === 'rate') {
            if (_.isUndefined(this.matchedCandidatesContainer.searchObject.rate) || this.matchedCandidatesContainer.searchObject.rate < 0) {
                this.matchedCandidatesContainer.searchObject.rate = 1;
            }
            this._setAssociateCandidateDisplayFilters('rate');
            if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
                (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
                this._setAssociateCandidateDisplayFilters('salary');
            }
        }
    }
    _checkIfCandidatesInformationMatch(candidate) {
        let candidateInformationMatch = false;
        if (candidate.candidateAdditionalDetailsCard &&
            (this.associateCandidatesDefaultFilterCopy.jobTypes.length === 0 || candidate.candidateAdditionalDetailsCard.preferredJobIcon === 'GREEN') &&
            ((!this.associateCandidatesDefaultFilterCopy.salary && !this.associateCandidatesDefaultFilterCopy.rate) || candidate.candidateAdditionalDetailsCard.salaryIcon === 'GREEN') &&
            (this.associateCandidatesDefaultFilterCopy.sponsorships.length === 0 || candidate.candidateAdditionalDetailsCard.sponsorshipIcon === 'GREEN') &&
            (this.associateCandidatesDefaultFilterCopy.workLocationIds.length === 0 || (candidate.workLocationsMatchStatus && candidate.workLocationsMatchStatus === 'match'))) {
            candidateInformationMatch = true;
        }
        return candidateInformationMatch;
    }
    _setMessageCandidateInformation(candidate) {
        let messageOptions = [];
        if (candidate.candidateAdditionalDetailsCard) {
            if (this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && candidate.candidateAdditionalDetailsCard.preferredJobIcon != 'GREEN') {
                messageOptions.push("Preferred job types");
            }
            if ((this.associateCandidatesDefaultFilterCopy.salary || this.associateCandidatesDefaultFilterCopy.rate) && candidate.candidateAdditionalDetailsCard.salaryIcon != 'GREEN') {
                messageOptions.push("Salary");
            }
            if (this.associateCandidatesDefaultFilterCopy.sponsorships.length > 0 && candidate.candidateAdditionalDetailsCard.sponsorshipIcon != 'GREEN') {
                messageOptions.push("Sponsorships");
            }
            if (this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && (!candidate.workLocationsMatchStatus || candidate.workLocationsMatchStatus != 'match')) {
                messageOptions.push("Work locations");
            }
        }
        if (messageOptions.length > 0) {
            return messageOptions.toString().split(',').join(', ');
        }
        else {
            return "";
        }
    }
    addToSelectedCandidates(candidate) {
        if (!this._checkIfCandidatesInformationMatch(candidate) || (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
            let title = "Alert";
            let candidateName = candidate.name ? `<span class="font-bold">${candidate.name}</span>` : "Candidate's";
            let message = '';
            if (this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
                message = `<div>
                    ${this.setIsResumeRequiredForWorkflowMessage(candidate)}
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
            }
            else if (!this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
                message = `<div>
                    ${this.setIsResumeRequiredForWorkflowMessage(candidate)}
                    <p>${candidateName} '<span class="text-primary">${this._setMessageCandidateInformation(candidate)}</span>' entry does not match with the Requisition.</p>
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
            }
            else {
                message = `<div>
                    <p>${candidateName} '<span class="text-primary">${this._setMessageCandidateInformation(candidate)}</span>' entry does not match with the Requisition.</p>
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
            }
            this.alertsAndNotificationsService.showConfirm(title, message, "warning", false, () => {
                this.selectCandidate(candidate);
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, () => {
                //do nothing
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
        else {
            this.selectCandidate(candidate);
        }
    }
    selectCandidate(candidate) {
        if (candidate.showOverride) {
            this.matchedCandidatesContainer.selectedCandidates.push(candidate);
            this._confirmOverrideSuspension(candidate);
        }
        else if (candidate.allowManualMatch) {
            candidate.selectedFlag = true;
            this.matchedCandidatesContainer.selectedCandidates.push(candidate);
        }
        else {
            this._showBootboxWarning(candidate.reasonForNoManualMatch);
        }
        this.$scope.$emit('candidateList:filtered');
    }
    _confirmOverrideSuspension(candidate) {
        let message = candidate.reasonForNoManualMatch;
        let allowOverride = candidate.allowOverride;
        let suspendedMonths = 0;
        let releaseDate = '';
        let releasedJobDetails = {};
        let type = "release";
        let candidateId = candidate.id;
        let candidateName = candidate.name;
        if (candidate.overrideFor == "JOB_LEFT") {
            suspendedMonths = candidate.jobLeftDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.jobLeftDetail.leftAt);
            releasedJobDetails = candidate.jobLeftDetail;
            type = "jobLeft";
        }
        else {
            suspendedMonths = candidate.releasedCandidateDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.releasedCandidateDetail.releasedAt);
            releasedJobDetails = candidate.releasedCandidateDetail;
        }
        // if(type == 'release') {
        //     message = "Candidate '<span class='emerald'>" + candidate.name + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        //     message = message + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // } else {
        //     message = "Candidate <span class='emerald'>'" + candidate.name + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        //     message = message + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // }
        // message = message + "<br>Would you like to override?";
        if (allowOverride) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Override',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    let vm = this;
                    if (result) {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        $(".modal").addClass("associate-candidate-modal");
                        this.$timeout(() => {
                            this.warningModal = this.$uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                backdrop: 'static',
                                windowClass: 'four-dot-five-modal-medium',
                                template: AssociatesCandidateActionsModalTemplate.default,
                                backdrop: false,
                                controller: ['$uibModalInstance', 'candidateId', 'candidateName', 'suspendedMonths', 'releaseDate', 'allowOverride', 'releasedJobDetails', 'type', function ($uibModalInstance, candidateId, candidateName, suspendedMonths, releaseDate, allowOverride, releasedJobDetails, type) {
                                        let ctrl = this;
                                        ctrl.candidateId = candidateId;
                                        ctrl.candidateName = candidateName;
                                        ctrl.suspendedMonths = suspendedMonths;
                                        ctrl.releaseDate = releaseDate;
                                        ctrl.allowOverride = allowOverride;
                                        ctrl.recruiterDetails = new OverrideNoteDetail(ctrl.candidateId);
                                        ctrl.releasedJobDetails = releasedJobDetails;
                                        ctrl.type = type;
                                        ctrl.modalTitle = "Override";
                                        ctrl.saveCallback = () => {
                                            if (type === "release") {
                                                candidate.releasedCandidateDetail.releasedAt = null;
                                            }
                                            else {
                                                candidate.jobLeftDetail.leftAt = null;
                                            }
                                            vm.createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                                            $uibModalInstance.close('cancel');
                                        };
                                        ctrl.closeModal = () => {
                                            vm.removeCandidate(candidate);
                                            $uibModalInstance.close('cancel');
                                        };
                                    }],
                                controllerAs: 'associateCandidatesActionModal',
                                size: 'md',
                                resolve: {
                                    candidateId: () => {
                                        return candidateId;
                                    },
                                    candidateName: () => {
                                        return candidateName;
                                    },
                                    suspendedMonths: () => {
                                        return suspendedMonths;
                                    },
                                    releaseDate: () => {
                                        return releaseDate;
                                    },
                                    allowOverride: () => {
                                        return allowOverride;
                                    },
                                    releasedJobDetails: () => {
                                        return releasedJobDetails;
                                    },
                                    type: () => {
                                        return type;
                                    }
                                }
                            });
                        }, 300);
                    }
                    else {
                        vm.removeCandidate(candidate);
                        vm.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            let displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.removeCandidate(candidate);
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }
    _showBootboxWarning(message) {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }, callback: () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    removeCandidate(candidate) {
        _.remove(this.matchedCandidatesContainer.selectedCandidates, {
            id: candidate.id
        });
        _.remove(this.createJobMatchesObject.overrideNoteDetail, {
            candidateId: candidate.id
        });
        let index = _.findIndex(this.matchedCandidatesContainer.candidates, {
            id: candidate.id
        });
        if (index >= 0) {
            this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
        }
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
    }
    _createSlimScroll() {
        this.$timeout(() => {
            $('.associate-candidates-matched-candidates-div').slimScroll({
                start: 'top',
                alwaysVisible: false,
                railVisible: false,
                wheelStep: 20,
                allowPageScroll: true,
                height: '350px'
            });
            $('.associate-candidates-selected-candidates-div').slimScroll({
                start: 'top',
                alwaysVisible: false,
                railVisible: false,
                wheelStep: 20,
                allowPageScroll: true,
                height: '380px'
            });
        }, 100);
    }
    _getBasicCandidateInfo(candidate) {
        let basicCandidateInfo = {};
        basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
        basicCandidateInfo.id = candidate.id;
        basicCandidateInfo.email = candidate.contact.email;
        basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
        basicCandidateInfo.workPhone = candidate.contact.workphone;
        basicCandidateInfo.matchScore = candidate.matchScore;
        basicCandidateInfo.candidateStatus = candidate.candidateStatus;
        if (!_.isNull(candidate.lastModifiedDate)) {
            basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
        }
        basicCandidateInfo.candidateJobMatches = [];
        basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
        if (_.isNull(basicCandidateInfo.matchScore)) {
            basicCandidateInfo.matchScore = 'N/A';
        }
        else {
            basicCandidateInfo.intelligenceScorePassFlag = false;
            if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
                basicCandidateInfo.intelligenceScorePassFlag = true;
            }
            // round the match score to the lower integer value.
            basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
        }
        basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
        basicCandidateInfo.showOverride = candidate.showOverride;
        basicCandidateInfo.allowOverride = candidate.allowOverride;
        basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
        basicCandidateInfo.releaseDate = candidate.releaseDate;
        basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
        basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
        basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
        basicCandidateInfo.overrideFor = candidate.overrideFor;
        basicCandidateInfo.resumeExist = candidate.resumeExist;
        basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;
        return basicCandidateInfo;
    }
    getCandidateJobMatches(candidateId, successCallback) {
        let candidateJobMatches = [];
        let jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = candidateId;
        jobMatchesObject.userId = this.$rootScope.userDetails.id;
        jobMatchesObject.companyId = this.$rootScope.userDetails.company.companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = "OWN_CANDIDATES";
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.candidateService.getCandidateJobMatches(jobMatchesObject, 1, 250, (data) => {
            angular.forEach(data, (val, key) => {
                val.jobMatchDate = new Date(val.jobMatchDate);
                candidateJobMatches.push(val);
            });
            if (successCallback) {
                successCallback(candidateJobMatches);
            }
        }, (error) => {
            console.log('candidate job matches get error - ', error);
            // do nothing.
        });
    }
    selectAllCandidates() {
        this.matchedCandidatesContainer.selectAllDoneFlag = true;
        let tempSearchObject = angular.copy(this.matchedCandidatesContainer.searchObject);
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        tempSearchObject.page = 1;
        tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
        let selectingAllCandidatesDialog = bootbox.dialog({
            message: '<p class="text-center">Selecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        tempSearchObject.loggedInUserId = this.$rootScope.userDetails.id;
        this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data) => {
            selectingAllCandidatesDialog.modal('hide');
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(data.candidateMinimumInfoDtos, (val, key) => {
                let basicCandidateInfo = this._getBasicCandidateInfo(val);
                let indexInSelectedCandidates = _.findIndex(this.matchedCandidatesContainer.selectedCandidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is not already in the selected candidates list, select the candidate
                if (indexInSelectedCandidates < 0) {
                    this.selectCandidate(basicCandidateInfo);
                }
                let indexInVisibleCandidates = _.findIndex(this.matchedCandidatesContainer.candidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is already in the visible candidates list, make the candidate selected
                if (indexInVisibleCandidates >= 0) {
                    this.matchedCandidatesContainer.candidates[indexInVisibleCandidates].selectedFlag = true;
                }
            });
        }, (error) => {
            selectingAllCandidatesDialog.modal('hide');
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    deselectAllCandidates() {
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        let tempSearchObject = angular.copy(this.matchedCandidatesContainer.searchObject);
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        tempSearchObject.page = 1;
        tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
        let selectingAllCandidatesDialog = bootbox.dialog({
            message: '<p class="text-center">Deselecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        tempSearchObject.loggedInUserId = this.$rootScope.userDetails.id;
        this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data) => {
            selectingAllCandidatesDialog.modal('hide');
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(data.candidateMinimumInfoDtos, (val, key) => {
                let basicCandidateInfo = this._getBasicCandidateInfo(val);
                let indexInSelectedCandidates = _.findIndex(this.matchedCandidatesContainer.selectedCandidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is in the selected candidates list, remove the candidate
                if (indexInSelectedCandidates >= 0) {
                    this.removeCandidate(basicCandidateInfo);
                }
            });
        }, (error) => {
            selectingAllCandidatesDialog.modal('hide');
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    deselectAllSelectedCandidates() {
        angular.forEach(this.matchedCandidatesContainer.selectedCandidates, (val, key) => {
            let index = _.findIndex(this.matchedCandidatesContainer.candidates, {
                id: val.id
            });
            if (index >= 0) {
                this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
            }
        });
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        this.matchedCandidatesContainer.selectedCandidates = [];
    }
    onTopMatchFilterMatchesFilterChange() {
        this.onGlobalFilterChange();
        this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
        if (this.matchedCandidatesContainer.searchObject.topMatches == 0) {
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
        }
        else {
            this.displayAssociateCandidateSelectedFilter.topMatches = this.topMatchesOptions.filter(topMatch => topMatch.value == this.matchedCandidatesContainer.searchObject.topMatches)[0].text;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    onLastModifiedFilterChange() {
        this.onGlobalFilterChange();
        if (this.matchedCandidatesContainer.searchObject.numberOfDays == 0) {
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
        }
        else {
            this.displayAssociateCandidateSelectedFilter.numberOfDays = this.lastModifiedOptions.filter(lastModified => lastModified.value == this.matchedCandidatesContainer.searchObject.numberOfDays)[0].text;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    searchTypeChanged() {
        if (!this.isFilterOpen) {
            this.onGlobalFilterChange();
        }
        if (!this.matchedCandidatesContainer.searchByTextFlag) {
            // reset the 'number of days' filter to zero
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
            this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
            this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
            //top matches reset to zero
            this.matchedCandidatesContainer.topMatches = 0;
            this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
            this.displayAssociateCandidateSelectedFilter.searchText = '';
            this.displayAssociateCandidateSelectedFilter.score = this._setJobMatchScoreDisplayFilter(this.matchedCandidatesContainer.searchObject.minimumScore, this.matchedCandidatesContainer.searchObject.maximumScore);
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
            this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
            this.sortRequisitions('Score Desc', 'Score', 'Desc');
        }
        else {
            this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = this.isClearClicked ? false : true;
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
            delete this.matchedCandidatesContainer.searchObject.topMatches;
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
            this.displayAssociateCandidateSelectedFilter.score = '';
            this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
            this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
            this.sortRequisitions('Score Desc', 'Score', 'Desc');
        }
        this.onNoAdditionalChange();
        this.searchForMatchingCandidates();
    }
    _createMatchScoreSlider() {
        this.minimumScoreSliderPadding = this.jobDetails.fourDotFiveIntelligenceScore < 65 ? this.jobDetails.fourDotFiveIntelligenceScore : (this.jobDetails.fourDotFiveIntelligenceScore - 4);
        let sliderId = '#matchScoreSlider';
        $(sliderId).empty();
        $(sliderId).noUiSlider({
            range: [0.00, 100.00],
            start: [this.jobDetails.fourDotFiveIntelligenceScore, 100],
            margin: 1.00,
            handles: 2,
            connect: true,
            step: 1,
            slide: () => {
                let val = $(sliderId).val();
                this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0]);
                this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1]);
                this.minimumScoreSliderPadding = this.matchedCandidatesContainer.searchObject.minimumScore < 65 ? this.matchedCandidatesContainer.searchObject.minimumScore : (this.matchedCandidatesContainer.searchObject.minimumScore - 4);
                this.maximumScoreSliderPadding = this.matchedCandidatesContainer.searchObject.maximumScore < 65 ? this.matchedCandidatesContainer.searchObject.maximumScore : (this.matchedCandidatesContainer.searchObject.maximumScore - 4);
                //avoid overlapping of min and max slider values
                if (this.matchedCandidatesContainer.searchObject.minimumScore > 9 && this.matchedCandidatesContainer.searchObject.maximumScore - this.matchedCandidatesContainer.searchObject.minimumScore >= 0 && this.matchedCandidatesContainer.searchObject.maximumScore - this.matchedCandidatesContainer.searchObject.minimumScore <= 8) {
                    this.maximumScoreSliderTopPosition = 80;
                }
                else {
                    this.maximumScoreSliderTopPosition = 65;
                }
                $('#matchScoreSliderDisplayMinValue').addClass('job-match-score-slider-highlight-score');
                $('#matchScoreSliderDisplayMaxValue').addClass('job-match-score-slider-highlight-score');
                this.$scope.$apply();
                this.isFiltersChanged = true;
                this.displayAssociateCandidateSelectedFilter.score = this._setJobMatchScoreDisplayFilter(this.matchedCandidatesContainer.searchObject.minimumScore, this.matchedCandidatesContainer.searchObject.maximumScore);
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
            },
            set: () => {
                let val = $(sliderId).val();
                this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0]);
                this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1]);
                $('#matchScoreSliderDisplayMinValue').removeClass('job-match-score-slider-highlight-score');
                $('#matchScoreSliderDisplayMaxValue').removeClass('job-match-score-slider-highlight-score');
                this.onGlobalFilterChange();
            }
        });
        $(".noUi-origin.noUi-origin-upper").css('background', '#eee');
    }
    searchForMatchingCandidates() {
        this.isFiltersChanged = false;
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
        if (this.candidateFilterItemsSelected.length === 0) {
            this.displayCandidateFilterFlag = false;
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
        }
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        if (this.matchedCandidatesContainer && this.matchedCandidatesContainer.currentPromise && this.matchedCandidatesContainer.currentPromise.$$state) {
            if (this.matchedCandidatesContainer.currentPromise.$$state.status == 0) {
                this.genericService.cancelRequest(this.matchedCandidatesContainer.currentPromise);
            }
        }
        // reset the initial value of candidates exist flag to true
        this.matchedCandidatesContainer.candidatesExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.matchedCandidatesContainer.searchObject.page = 1;
        // clear select all candidates selection
        this.selectAllCandidatesFlag = false;
        // clear the existing candidates
        this.matchedCandidatesContainer.candidates = [];
        this.matchedCandidatesContainer.totalCandidateCount = null;
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        this.matchedCandidatesContainer.disableInfiniteScroll = false;
        // wait for the cancelled promise to be fulfilled.
        this.$timeout(() => {
            this.isFiltersChanged = false;
            this.matchedCandidatesContainer.getNext();
        }, 200);
    }
    associateCandidates() {
        let candidateIds = [];
        angular.forEach(this.matchedCandidatesContainer.selectedCandidates, (val, key) => {
            this.createJobMatchesObject.candidateIds.push(val.id);
            candidateIds.push({
                id: val.id,
                candidateType: val.candidateJobMatches.length > 0 ? val.candidateJobMatches[0].candidateType : 'OWN_CANDIDATES'
            });
        });
        this.savingFlag = true;
        let associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Associating Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this._associateCandidates(this.matchedCandidatesContainer.selectedCandidates, () => {
            associatingDialog.modal('hide');
        });
    }
    _associateCandidates(allSelectedCandidates, successCallback) {
        let selectedCandidates = [...allSelectedCandidates];
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data) => {
            this.savingFlag = false;
            if (successCallback) {
                successCallback();
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "Candidate(s) associated successfully.", "success", () => {
                if (this.saveCallback) {
                    this.saveCallback();
                }
                this.$timeout(() => {
                    this.sendOutreachEmailToCandidates(selectedCandidates);
                }, 500);
            });
        }, (error) => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    jobCompare(candidate) {
        let actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('associateCandidates', actionObject, candidate, () => {
        }, () => {
        });
    }
    onNoAdditionalChange() {
        if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails) {
            const selectDefault = (list, name) => {
                const item = list.find(i => i.name === name);
                return item ? Object.assign({}, item, { ticked: true }) : [];
            };
            if (this.selectedWorkLocations.length === 0 || !this.selectedWorkLocations.some(item => item && item.name === 'No Work Location')) {
                // Work Locations
                this.workLocations.forEach(workLocation => {
                    if (workLocation.name == 'No Work Location') {
                        workLocation.ticked = true;
                    }
                });
                this.selectedWorkLocations.push(selectDefault(this.workLocations, 'No Work Location'));
                this.onWorkLocationSelected();
            }
            if (this.selectedJobTypeList.length === 0 || !this.selectedJobTypeList.some(item => item && item.name === 'No Pref. Job Type')) {
                // Job Types
                this.jobTypeList.forEach(jobType => {
                    if (jobType.name == 'No Pref. Job Type') {
                        jobType.ticked = true;
                    }
                });
                this.selectedJobTypeList.push(selectDefault(this.jobTypeList, 'No Pref. Job Type'));
                this.onJobTypeSelected();
            }
            if (this.selectedWorkAuthorizationList.length === 0 || !this.selectedWorkAuthorizationList.some(item => item && item.name === 'No Work Authorization')) {
                // Work Authorizations
                this.workAuthorizationList.forEach(workAuth => {
                    if (workAuth.name == 'No Work Authorization') {
                        workAuth.ticked = true;
                    }
                });
                this.selectedWorkAuthorizationList.push(selectDefault(this.workAuthorizationList, 'No Work Authorization'));
                this.onWorkAuthorizationSelected();
            }
        }
        else {
            this.selectedWorkLocations = this.selectedWorkLocations.filter(workLocation => workLocation.id != 'NO_WORK_LOCATION');
            this.workLocations.forEach(workLocation => {
                if (workLocation.name == 'No Work Location') {
                    workLocation.ticked = false;
                }
            });
            this.onWorkLocationSelected();
            this.selectedJobTypeList = this.selectedJobTypeList.filter(workLocation => workLocation.name != 'No Pref. Job Type');
            this.jobTypeList.forEach(jobType => {
                if (jobType.name == 'No Pref. Job Type') {
                    jobType.ticked = false;
                }
            });
            this.onJobTypeSelected();
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(workLocation => workLocation.name != 'No Work Authorization');
            this.workAuthorizationList.forEach(workAuth => {
                if (workAuth.name == 'No Work Authorization') {
                    workAuth.ticked = false;
                }
            });
            this.onWorkAuthorizationSelected();
        }
        this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    }
    setIsResumeRequiredForWorkflowMessage(candidate) {
        if (this.resumeRequiredForWorkflow && !candidate.resumeExist) {
            return `<p class="font-bold text-danger">Since this requisition requires candidates with resumes, after association, any candidate without resumes must have their resumes uploaded in the workflow.</p>`;
        }
        else {
            return '';
        }
    }
    _setSalaryOrRateNotSpecified(type) {
        let isNoPrefJobTypeSelected = this.selectedJobTypeList.some(item => item && item.value === 'NO_PREF_JOBTYPE');
        if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
            (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
            this.isDisplayRateFilterActive = true;
            if (type === 'rate' && this.matchedCandidatesContainer.searchObject.rate) {
                return " OR Rate = Not Specified";
            }
            else if (type === 'salary' && this.matchedCandidatesContainer.searchObject.salary) {
                return " OR Salary = Not Specified";
            }
        }
        else {
            return "";
        }
    }
    sendOutreachEmailToCandidates(selectedCandidates) {
        let windowClass = 'four-dot-five-modal-small';
        let validCandidatesToSendOutreachEmail = [];
        let notValidCandidatesToSendOutreachEmail = [];
        let selectedJobMatchesForOutreach = [];
        let isSingleCandidateSelected = false;
        let candidateId = '';
        let candidateType = '';
        let companyId = this.$rootScope.userDetails.company.companyId;
        let userId = this.$rootScope.userDetails.id;
        selectedCandidates.map((candidate, index) => {
            let tempObject = {};
            tempObject.jobMatchId = "";
            tempObject.candidateId = candidate.id;
            tempObject.workflowStepName = "";
            tempObject.candidateName = candidate.name;
            tempObject.message = "";
            tempObject.selected = true;
            tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
            if (!candidate.email) {
                tempObject.message = "Email ID not available.";
                notValidCandidatesToSendOutreachEmail.push(tempObject);
            }
            else {
                validCandidatesToSendOutreachEmail.push(tempObject);
                if (selectedCandidates.length == 1) {
                    selectedJobMatchesForOutreach = [...selectedCandidates];
                }
            }
        });
        isSingleCandidateSelected = selectedCandidates.length == 1 && validCandidatesToSendOutreachEmail.length == 1 ? true : false;
        if (isSingleCandidateSelected) {
            selectedJobMatchesForOutreach[0].candidateJobMatches.forEach((jobMatch) => {
                jobMatch.requisitionNumber = jobMatch.requisitionNumber;
                jobMatch.jobTitle = jobMatch.title;
                jobMatch.companyName = jobMatch.company;
                jobMatch.jobLocationText = this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
                jobMatch.jobId = jobMatch.jobId;
                selectedJobMatchesForOutreach[0].candidateId = selectedJobMatchesForOutreach[0].id;
                candidateType = candidateType != '' ? candidateType : jobMatch.candidateType;
            });
            windowClass = 'four-dot-five-modal-large';
            candidateId = selectedJobMatchesForOutreach[0].id;
            selectedJobMatchesForOutreach[0].activeJobId = this.jobId;
        }
        let label = isSingleCandidateSelected ? `Send outreach to Candidate <b>'${selectedJobMatchesForOutreach[0].name}'</b>` : "Send outreach to Candidates";
        let vm = this;
        $(".modal").addClass("associate-candidate-modal");
        this.sendOutreachEmailModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateSendOutreachEmailModal.default,
            backdrop: 'static',
            windowTopClass: windowClass,
            controller: ['$uibModalInstance', 'label', 'validCandidatesToSendOutreachEmail', 'notValidCandidatesToSendOutreachEmail', 'isSingleCandidateSelected', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'selectedJobMatchesForOutreach', 'context',
                function ($uibModalInstance, label, validCandidatesToSendOutreachEmail, notValidCandidatesToSendOutreachEmail, isSingleCandidateSelected, companyId, userId, candidateId, clientOrBUId, candidateType, selectedJobMatchesForOutreach, context) {
                    let ctrl = this;
                    ctrl.label = label;
                    ctrl.validCandidatesToSendOutreachEmail = validCandidatesToSendOutreachEmail;
                    ctrl.notValidCandidatesToSendOutreachEmail = notValidCandidatesToSendOutreachEmail;
                    ctrl.isSingleCandidateSelected = isSingleCandidateSelected;
                    ctrl.companyId = companyId;
                    ctrl.userId = userId;
                    ctrl.candidateId = candidateId;
                    ctrl.clientOrBUId = clientOrBUId;
                    ctrl.candidateType = candidateType;
                    ctrl.selectedJobMatchesForOutreach = selectedJobMatchesForOutreach;
                    ctrl.context = context;
                    ctrl.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    ctrl.saveCallback = () => {
                        if (isSingleCandidateSelected) {
                            ctrl.closeModal();
                            vm.resetCandidateJobMatches();
                        }
                        else {
                            let passedCandidateList = [];
                            if (ctrl.validCandidatesToSendOutreachEmail.length > 0) {
                                ctrl.validCandidatesToSendOutreachEmail.map(candidate => {
                                    if (candidate.selected) {
                                        passedCandidateList.push({
                                            id: candidate.candidateId,
                                            candidateType: candidate.candidateType,
                                            source: 'CANDIDATE_CARD',
                                            jobIds: [vm.jobId],
                                            jobMatchId: ""
                                        });
                                    }
                                });
                            }
                            if (passedCandidateList.length > 0) {
                                let outreachObject = {
                                    candidates: passedCandidateList,
                                    userId: userId,
                                    companyId: companyId,
                                    clientOrBuId: vm.clientOrBuId
                                };
                                vm.candidateService.sendOutreachEmail(outreachObject, (data) => {
                                    vm.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                    ctrl.closeModal();
                                }, (error) => {
                                    ctrl.closeModal();
                                    vm.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                });
                            }
                            else {
                                let title = "No candidates selected";
                                let message = "Please select atleast one candidate.";
                                vm.alertsAndNotificationsService.showAlert(title, message, "warning");
                            }
                        }
                    };
                    ctrl.cancelCallback = () => {
                        ctrl.closeModal();
                    };
                }],
            controllerAs: 'sendOutreachEmailModal',
            size: 'lg',
            resolve: {
                validCandidatesToSendOutreachEmail: () => {
                    return validCandidatesToSendOutreachEmail;
                },
                notValidCandidatesToSendOutreachEmail: () => {
                    return notValidCandidatesToSendOutreachEmail;
                },
                label: () => {
                    return label;
                },
                isSingleCandidateSelected: () => {
                    return isSingleCandidateSelected;
                },
                companyId: () => {
                    return companyId;
                },
                userId: () => {
                    return userId;
                },
                candidateId: () => {
                    return candidateId;
                },
                clientOrBUId: () => {
                    return vm.clientOrBuId;
                },
                candidateType: () => {
                    return candidateType;
                },
                selectedJobMatchesForOutreach: () => {
                    return selectedJobMatchesForOutreach;
                },
                context: () => {
                    return 'associateCandidates';
                }
            }
        });
    }
}
AssociateCandidatesController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$filter', 'jobService', 'jobMatchActionsService', 'candidateService', 'jobMatchService', 'companyService', 'genericService', 'modalService', 'debounceService', 'alertsAndNotificationsService', 'requisitionService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './associate-candidates.html';
import * as TEMPLATE from 'raw-loader!./associate-candidates.html';
export const AssociateCandidatesComponent = {
    selector: 'associateCandidates',
    component: {
        bindings: {
            jobId: '@',
            clientOrBuName: '@',
            corporateId: '@',
            clientOrBuId: '@',
            isSharedRequisition: '<',
            resumeRequiredForWorkflow: '<',
            saveCallback: '&'
        },
        controller: AssociateCandidatesController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates.html'
    }
};
//# sourceMappingURL=associate-candidates.component.js.map